import React,{useState} from 'react';
import {collection,getDocs} from 'firebase/firestore';
import {db} from '../../Security/firebase-config';
import {hasSetupMap,setupKey} from '../../utils/eventSetup';
import {saveSetupMap} from '../../utils/eventSetupStore';
import {getImprovementNoteMapOptions} from '../../utils/teamPlanning';
import {Pencil} from 'lucide-react';

export default function WorkspaceMapLabel({event,slot,canEdit=false}) {
 const [editing,setEditing]=useState(false),[maps,setMaps]=useState([]),[selected,setSelected]=useState(''),[busy,setBusy]=useState(false),[error,setError]=useState('');
 if(hasSetupMap(slot))return <>{slot.mapName||slot.mapId}</>;
 async function open(){
  setEditing(true);setBusy(true);setError('');
  try{const snap=await getDocs(collection(db,'teams',event.__teamId,'maps'));setMaps(getImprovementNoteMapOptions(snap.docs.map(d=>({...d.data(),id:d.id}))));}
  catch{setError('Maps could not be loaded. Retry selecting the map.');}
  finally{setBusy(false);}
 }
 async function save(){
  const map=maps.find(m=>m.id===selected);if(!map)return;
  setBusy(true);setError('');
  try{await saveSetupMap({teamId:event.__teamId,key:setupKey(event,slot.id),mapId:map.id,mapName:map.name});setEditing(false);}
  catch(e){setError(e.message||'The map could not be saved.');}
  finally{setBusy(false);}
 }
 return <span className="WorkspaceMapLabel">{!editing?<button type="button" className="WorkspaceMapLabel__trigger" disabled={!canEdit} onClick={open} title={canEdit?'Choose the event map':'Preparation staff can choose the event map'}>Map TBD {canEdit&&<Pencil size={12}/>}</button>:<span className="WorkspaceMapLabel__editor"><select aria-label="Choose event map" value={selected} disabled={busy} onChange={e=>setSelected(e.target.value)}><option value="">Choose map…</option>{maps.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}</select><button type="button" disabled={busy||!selected} onClick={save}>Save map</button><button type="button" disabled={busy} onClick={()=>setEditing(false)}>Cancel</button><small>This selects the shared event map in both workspaces.</small></span>}{error&&<span role="alert">{error}</span>}</span>;
}
